import React, { FC, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { Grid, TextField } from "@mui/material";
import { SCUIButton } from "../../../atomic/atoms";
import Swal from "sweetalert2";
import { CookieManagementCommand } from "../../../services/command";
import { useTranslation } from "react-i18next";
import { CKT, cktCls } from "../cookieType.classes";

interface IProps {
  selectedRow?: any;
  onCloseMenu?: any;
  onUpdate?: any;
  cookieType?: any;
}

export const SCUICookieTypeDrawerContent: FC<IProps> = ({
  selectedRow,
  onCloseMenu,
  onUpdate,
  cookieType,
}) => {
  const { t } = useTranslation();
  const [cookieTypeDescripton, setCookieTypeDescripton] = React.useState(
    selectedRow ? selectedRow.cookieTypeDescripton : ""
  );
  const [priorty, setPriorty] = React.useState(
    selectedRow ? selectedRow.priority : 0
  );
  const [selectedStatus, setSelectedStatus] = useState<any>(
    selectedRow ? selectedRow.status : false
  );
  const [cookieTypeName, setCookieTypeName] = React.useState<any>(
    selectedRow ? selectedRow.cookieTypeName : ""
  );
  const [cookieTypeId, setCookieTypeId] = React.useState<any>(
    selectedRow ? selectedRow.id : 0
  );

  const handleCookieTypeDescripton = (event: any) => {
    setCookieTypeDescripton(event.target.value);
  };
  const handleCookieTypeId = (event: any) => {
    setCookieTypeId(event.target.value);
  };
  const handleChangeCookieName = (event: any) => {
    setCookieTypeName(event.target.value);
  };
  const handleChangePriorty = (event: any) => {
    setPriorty(event.target.value);
  };
  const handleSelectChangeIsActive = (event: any) => {
    setSelectedStatus(event.target.value);
  };

  const statusItems = [
    { label: "Aktif", value: true },
    { label: "Pasif", value: false },
  ];
  console.info(cookieType);
  const parsedCookieTypeIds = cookieType.map((item: any) => item.id);

  const handleCheckTypeId = (id: any) => {
    return !parsedCookieTypeIds.includes(parseInt(id));
  };
  const UpdateCookieType = () => {
    Swal.fire({
      text: "Güncellemek istediğinizden emin misiniz",
      cancelButtonText: t("general.cancel"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("general.update"),
    }).then((result: any) => {
      if (result.isConfirmed) {
        let params: any = {};
        params.cookieTypeId = selectedRow.id;
        params.status = selectedStatus;
        params.cookieTypeName = cookieTypeName;
        params.cookieTypeDescripton = cookieTypeDescripton;
        params.priorty = priorty;
        const isValid =
          cookieTypeDescripton &&
          cookieTypeDescripton?.trim().length > 0 &&
          cookieTypeName &&
          cookieTypeName?.trim().length > 0;

        if (isValid) {
          CookieManagementCommand.UpdateCookieType(params)
            .then((_res: any) => {
              onUpdate();
              Swal.fire(t("general.updated"), " ", "success");
              onUpdate();
              onCloseMenu();
            })
            .catch((error: any) => {
              console.log("Hata :>> ", error);
            })
            .finally(() => {});
        } else {
          Swal.fire(t("mobilePanel.noEmpty"), " ", "error");
        }
      }
    });
  };
  const CreateCookieType = async () => {
    let params: any = {};
    params.cookieTypeDescripton = cookieTypeDescripton;
    params.priority = priorty;
    params.cookieTypeName = cookieTypeName;
    params.cookieTypeId = cookieTypeId;
    params.status = selectedStatus;
    console.info(cookieTypeId);
    const isTypeIdValid = handleCheckTypeId(cookieTypeId);
    const isValid =
      cookieTypeDescripton &&
      cookieTypeDescripton?.trim().length > 0 &&
      cookieTypeName &&
      cookieTypeName?.trim().length > 0;

    if (!isTypeIdValid) {
      Swal.fire(
        t("Bu Çerez Id var, lütfen başka bir değer giriniz."),
        " ",
        "error"
      );
      return;
    }

    if (!isValid) {
      Swal.fire(t("mobilePanel.noEmpty"), " ", "error");
      return;
    }

    CookieManagementCommand.CreateCookieType(params)
      .then((_res: any) => {
        Swal.fire(t("general.added"), " ", "success");
        onUpdate();
        onCloseMenu();
      })
      .catch((error: any) => {
        console.log("Hata :>> ", error);
      })
      .finally(() => {});
    //:Swal.fire(t('general.emptyFieldControlText'), " ", "error");
  };
  return (
    <Grid className={CKT.drawer}>
      <Grid container sx={{ paddingTop: "2rem" }} className={CKT.drawerHeader}>
        <Grid
          sx={{ paddingLeft: "3rem" }}
          size={{
            md: 6,
            xs: 6,
            lg: 11
          }}>
          <h1 className="headtxt">
            {selectedRow?.cookieTypeDescripton
              ? "Çerez Tipi Bilgisi Güncelle"
              : "Çerez Tipi Ekleme"}
          </h1>
        </Grid>

        <Grid
          size={{
            md: 1,
            xs: 1,
            lg: 1
          }}>
          <CloseIcon className={cktCls("svg_icons", CKT.drawerClose)} onClick={onCloseMenu} />
        </Grid>
      </Grid>
      <Grid container sx={{ padding: "3rem" }} className={CKT.drawerBody}>
        <br />
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <TextField
            label={"Çerez Tipi"}
            margin="dense"
            id="parameterValue"
            fullWidth
            value={cookieTypeName}
            className={cktCls(CKT.input, CKT.inputTextfield, CKT.fieldCookieTypeName)}
            onChange={handleChangeCookieName}
            multiline
          />
        </Grid>

        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <TextField
            label={"Çerez Açıklaması"}
            margin="dense"
            id="parameterValue"
            fullWidth
            value={cookieTypeDescripton}
            className={cktCls(CKT.input, CKT.inputTextfield, CKT.fieldCookieTypeDescription)}
            onChange={handleCookieTypeDescripton}
            multiline
          />
        </Grid>
        {selectedRow?.id > 0 && (
          <Grid
            size={{
              md: 12,
              xs: 12
            }}>
            <TextField
              label={"Çerez Id"}
              margin="dense"
              id="parameterValue"
              fullWidth
              value={cookieTypeId}
              className={cktCls(CKT.input, CKT.inputTextfield, CKT.fieldCookieTypeId)}
              onChange={handleCookieTypeId}
              disabled={true}
              type="number"
            />
          </Grid>
        )}
        {(selectedRow?.id === undefined || selectedRow?.id === null) && (
          <Grid
            size={{
              md: 12,
              xs: 12
            }}>
            <TextField
              label={"Çerez Id"}
              type="number"
              margin="dense"
              id="parameterValue"
              fullWidth
              value={cookieTypeId}
              className={cktCls(CKT.input, CKT.inputTextfield, CKT.fieldCookieTypeId)}
              onChange={handleCookieTypeId}
            />
          </Grid>
        )}
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <TextField
            label={"Öncelik Sırası"}
            margin="dense"
            id="parameterValue"
            fullWidth
            value={priorty}
            className={cktCls(CKT.input, CKT.inputTextfield, CKT.fieldPriority)}
            onChange={handleChangePriorty}
            type="number"
          />
        </Grid>
        <Grid
          size={{
            md: 12,
            xs: 12
          }}>
          <FormControl fullWidth className={CKT.fieldStatusSelect}>
            <InputLabel id="select-label">
              {t("customerInformation.isActive")}
            </InputLabel>
            <Select
              labelId="status-select-label"
              value={selectedStatus}
              onChange={handleSelectChangeIsActive}
              label={t("customerInformation.isActive")}
              className={cktCls(CKT.input, CKT.inputSelect, CKT.fieldStatusSelect)}
            >
              {statusItems.map((item: any) => (
                <MenuItem key={item.value.toString()} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          container
          className={CKT.drawerActions}
          justifyContent={"flex-end"}
          sx={{ marginTop: "2rem" }}
          size={{
            xs: 12,
            sm: 12
          }}>
          {selectedRow?.cookieTypeDescripton ? (
            <SCUIButton
              text={"Güncelle"}
              type="primary"
              sizeType="fixed"
              size={"l"}
              className={cktCls(CKT.input, CKT.inputButton, CKT.btnDrawerUpdate)}
              onClick={() => UpdateCookieType()}
            ></SCUIButton>
          ) : (
            <SCUIButton
              text={"Kaydet"}
              type="primary"
              sizeType="fixed"
              size={"l"}
              className={cktCls(CKT.input, CKT.inputButton, CKT.btnDrawerSave)}
              onClick={() => CreateCookieType()}
            ></SCUIButton>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
